import { Box, Flex, Spinner, Text, VStack, Avatar, useDisclosure } from "@chakra-ui/react";
import React, { useCallback, useState } from "react";
import { Select } from "antd";
import { GoSettings } from "react-icons/go";
import { mutateFunction, useMutation } from "../../libs/apis";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FiSearch } from "react-icons/fi";
// import IsDesktop from "../../utils/IsDesktop";

const SearchBar = ({
    styles = {},
    className = "",
    avatarSize = "sm",
    userType = "all",
    searchType = "user",
    searchRoute = "",
    status = null,
    onSelectOption = () => { }
}) => {
    const { mutate, isLoading } = useMutation(mutateFunction)
    const loggedInUserStatus = useSelector((state) => state?.user?.userInfo?.status || "");
    const [input, setInput] = useState("")
    const [searchData, setSearchData] = useState([])
    const { OptGroup } = Select;
    const { isOpen: userIsOpen, onToggle: onToggleUser } = useDisclosure();
    const [isActive, setIsActive] = useState(false);

    const toggleSearch = () => {
        setIsActive(!isActive);
    };

    const navigate = useNavigate();

    const search = useCallback((inputValue) => {
        if (inputValue !== "" && loggedInUserStatus !== "disabled") {
            const encodedQuery = encodeURIComponent(inputValue);
            mutate(
                { key: searchType !== "user" && searchRoute ? `${searchRoute}?q=${encodedQuery}` : `search-users?q=${encodedQuery}&type=${userType}${status ? `&status=${status}` : ''}`, method: "get" },
                {
                    onSuccess(res) {
                        setSearchData(res.data.users)
                    }
                })
        }
    }, [mutate, userType, status, searchType, searchRoute, loggedInUserStatus])

    const goToUser = (userId) => {
        const user = searchData?.find((user) => user.id.toString() === userId)
        navigate(`../view-user?userid=${userId}&usertype=${user?.userTypeId}`)
    }

    const goToOffer = (id) => {
        const offer = searchData?.find((offer) => offer.id.toString() === id)
        onSelectOption(offer)
    }

    const goToDeletedUser = (id) => {
        const deletedUser = searchData?.find((offer) => offer.id.toString() === id)
        onSelectOption(deletedUser)
    }

    const onSelectOptions = {
        "user": goToUser,
        "offer": goToOffer,
        "deleted-user": goToDeletedUser
    }

    const tabs = {
        "user": (item) => (
            <Flex alignItems="center">
                <Avatar size={avatarSize} name={`${item.first_name} ${item.last_name}`} src={item.profile_image} />
                <Text className="capitalize" ml={4}>{`${item.first_name} ${item.last_name}`}</Text>
            </Flex>
        ),
        "offer": (item) => (
            <Flex alignItems="center">
                <Avatar size={avatarSize} name={`${item.title}`} src={''} />
                <Text ml={4}>{`${item.title}`}</Text>
            </Flex>
        ),
        "deleted-user": (item) => (
            <Flex alignItems="center">
                <Avatar size={avatarSize} name={`${item.firstName} ${item.lastName}`} />
                <Text className="capitalize" ml={4}>{`${item.firstName} ${item.lastName}`}</Text>
            </Flex>
        ),
    }

    const searchResults = searchData?.map((item) => <Select.Option key={item.id}>
        {tabs[searchType] ? tabs[searchType](item) : null}
    </Select.Option>
    );


    return (
        <>
            <Box className="flex items-center my-1 gap-1">
                <Box
                >
                    <Box
                        className={`transition-all duration-500 ease-in-out min-h-[38px] ${isActive ? 'w-32 xs:w-60 opacity-100' : 'w-0 opacity-0'
                            }`}
                        mx={2}>
                        {
                            isActive ? (
                                <Select key="globalSelect"
                                    size="large"
                                    showSearch
                                    labelInValue={false}
                                    autoClearSearchValue
                                    // autoFocus
                                    allowClear
                                    // value={input}
                                    listHeight={500}
                                    placeholder="Search"
                                    style={{ ...styles }}
                                    className={`w-32 xs:w-60 xl:w-full max-w-[400px] max-h-[500px] rounded-sm ${className}`}
                                    defaultActiveFirstOption={false}
                                    showArrow={false}
                                    filterOption={false}
                                    onSearch={search}
                                    onChange={setInput}
                                    notFoundContent={isLoading ? <Spinner /> : "No data to show"}
                                    onSelect={onSelectOptions[searchType] ? onSelectOptions[searchType] : onSelectOptions["user"]}
                                //   onBlur={onblur}
                                >
                                    {!isLoading && (
                                        <>
                                            <OptGroup key="Users" label="Users">{searchResults.length > 0 ? searchResults : <Select.Option key="searchDatanull" fontSize="3px">No match found</Select.Option>}</OptGroup>
                                        </>)}
                                </Select>
                            ) : null
                        }
                    </Box>

                </Box>
                <Box className="bg-[#E9E9E9] p-2 cursor-pointer flex items-center justify-center rounded-full">
                    <button onClick={toggleSearch} className="text-xl text-gray-600 focus:outline-none">
                        <FiSearch className="text-[24px]" />
                    </button>
                </Box>
            </Box>
        </>
    )
}
export default SearchBar; 